import React, { useEffect, useState } from "react";
import "./JuryRoundExistingData.scss";
import { TitleBar } from "../../../../Global/TitleBar/TitleBar";
import { TopBar } from "../../../TopBar/TopBar";
import {
  CreateButton,
  GreyfilterButton,
} from "../../../../Global/GlobalButton";
import {
  MdEditSquare,
  MdOutlineRefresh,
  MdOutlineSettings,
} from "react-icons/md";
import {
  DescriptionContent,
  EventHeading,
  GreenContent,
  JuryRound,
  RedContent,
  RedMainHeading,
} from "../../../../Global/GlobalText";
import { HiOutlineRefresh } from "react-icons/hi";
import { PiPlusCircleBold } from "react-icons/pi";
import { IoMdCheckmark } from "react-icons/io";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { IoSearchSharp } from "react-icons/io5";
import { LuFilter } from "react-icons/lu";
import { GlobalSecondTable } from "../../../../Global/GlobalSecondTable/GlobalSecondTable";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { EXCHNAGE_URL } from "../../../../../Url/Url";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useLoading } from "../../../../LoadingContext"; // ✅ ADD THIS

export const JuryRoundExistingData = ({ roundData }) => {
    const { setLoading } = useLoading(); // ✅ ADD THIS - Global loader

  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRound, setSelectedRound] = useState(null);
  const [selectedRoundId, setSelectedRoundId] = useState("");
  const [selectedButton, setSelectedButton] = useState(0);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const eventIdGet = useSelector((state) => state?.users?.id);
  const eventId = String(eventIdGet);
  const [loader, setLoader] = useState(false);
  const [shortlistedData, setShortlistedData] = useState([]);

  const token = localStorage.getItem("token");

  const handleRoundClick = (round) => {
    setSelectedRoundId(round.roundId);  
    setSelectedRound(round);           
    setIsDropdownVisible((prev) => !prev); 
  };
  
  useEffect(() => {
    if (selectedRoundId) {
      getShortlistedData();
    }
  }, [selectedRoundId]);
  
  const getShortlistedData = async () => {
    setLoader(true);
        setLoading(true); // ✅ ADD THIS - Start global loader

    try {
      const apiUrl = `${EXCHNAGE_URL}/getShortlist?eventId=${eventId}&roundId=${selectedRoundId}&is_shortlist=1`;
      const response = await axios.get(apiUrl, {
        headers: {
          "Content-Type": "Application/json",
          authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        console.log(response, "sesssss");
        setShortlistedData(response.data.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
      setLoading(false); // ✅ ADD THIS - Stop global loader
    }
  };
  
  useEffect(() => {
    if (eventId) {
      getShortlistedData();
    }
  }, [eventId]);

  console.log(roundData, "daaaatatatat");

  const columns = [
    { label: "Submission ID", accessor: "Submission ID" },
    { label: "Category", accessor: "Category" },
    { label: "Title", accessor: "Title" },
    { label: "Overall Score", accessor: "Overall Score" },
  ];

  const data = shortlistedData
    .filter((submission) => submission && submission.fields)
    .map((submission) => {
      const title =
        submission.fields.find((field) => field.field_name.startsWith("title"))
          ?.field_value || "";
      const category =
        submission.fields.find((field) =>
          field.field_name.startsWith("category")
        )?.field_value || "";

      return {
        rowId: submission.submission_id,
        "Submission ID": submission.submission_id,
        Category: category,
        Title: title,
        "Overall Score": submission.score !== null ? submission.score : "",
      };
    });


  const handleCheckboxChange = (rowIndex, isChecked) => {
    setSelectedRows((prevSelected) => {
      console.log("Previous Selected Rows:", prevSelected);
      return isChecked
        ? [...prevSelected, rowIndex]
        : prevSelected.filter((index) => index !== rowIndex);
    });
  };
  const setSelectedRow = (row) => {
    console.log("Selected row:", row);
  };

  console.log(selectedRows, "adsddsddsd");

  const handleClick = (index) => {
    setSelectedButton(index);

    if (index === 0) {
      setSelectedRows(data.map((row) => row.rowId));
    } else {
      setSelectedRows([]);
    }
  };

  const handleDelete = async () => {
    if (selectedRows.length === 0) {
      toast.error("No Shortlisted Data selected for deletion.");
      return;
    }
    setLoading(true); // ✅ ADD THIS - Start loader

    try {
      const apiUrl = `${EXCHNAGE_URL}/deleteShortlist`;
      const response = await axios.delete(apiUrl, {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
        data: { submission_ids: selectedRows , roundId:selectedRoundId },
      });

      if (response.status === 200) {
        getShortlistedData(); // Refresh the data
        toast.success("Shortlisted Data deleted successfully!");
        setSelectedRows([]); // Clear selection after deletion
      }
    } catch (error) {
      console.error("Error deleting Shortlisted Data :", error);
      toast.error("Failed to delete Shortlisted Data .");
    }
    finally {
      setLoading(false); // ✅ ADD THIS - Stop loader
    }
  };

  const handleNavigate = (roundId) => {
    navigate(`/update-jury-post/${roundId}`);
  };

  const navigate = useNavigate();
  const [showRoundDropdown, setShowRoundDropdown] = useState(false);

  const formatDateTime = (date, time) => {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, "0");
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[d.getMonth()];
    const year = d.getFullYear();

    return `${day} ${month} ${year} ${time}`;
  };

  
   
  return (
    <div>
      <div className="jury_existing_data_div">
        <TitleBar title="Jury Round" />
        <div className="jury_existing_data_white_bg">
          <TopBar titleheading="Jury Rounds" />
          <div className="jury_existing_data_btn">
            <div className="newBtn">
              <div>  
                <button
                className="Bt"
                  onClick={() => setIsDropdownVisible(!isDropdownVisible)}
                >
                  {isDropdownVisible ? "Hide Rounds" : "Show Rounds"}
                </button>

                {isDropdownVisible && (
  <div
    className={`dropdown-container ${isDropdownVisible ? "show" : ""}`}
  >
    {roundData.length !== 0 ? (
      roundData.map((round, index) => (
        <div
          key={round.roundId}
          className="round-button-container"
        >
          <CreateButton  className="Btt" onClick={() => handleRoundClick(round)}>
            {round.round_name}
          </CreateButton>
          {round.is_active === 1 ? (
                            <GreenContent>Active</GreenContent>
                          ) : (
                            <RedContent>Unactive</RedContent>
                          )}
                        </div>
                      ))
                    ) : (
                      <div>No rounds available</div>
                    )}
                  </div>
                )}
              </div>

              {selectedRound && (
                <CreateButton onClick={() => handleNavigate(selectedRound.roundId)}>
                  {selectedRound.round_name} <MdEditSquare />
                </CreateButton>
              )}

              <div>
                <CreateButton
                  onClick={() => {
                    navigate("/create-jury-round-post");
                  }}
                >
                  Create New Round
                </CreateButton>
              </div>
            </div>
          </div>

          {selectedRound ? (<>

            <div className="jury_existing_date_div">
              {selectedRound && (
               <DescriptionContent>
               From {formatDateTime(selectedRound.start_date, selectedRound.start_time)} to{" "}
               {formatDateTime(selectedRound.end_date, selectedRound.end_time)}
             </DescriptionContent>
              )}
              <div className="jury_existing_scorecard">
                {selectedRound && (
                  <RedContent onClick={() => handleNavigate(selectedRound.roundId)} style={{cursor:"pointer"}}>{`Scorecards(${selectedRound.total_scorecards})`}</RedContent>

                )}

                <GreenContent
                  className="jury_existing_plus_icon"
                  onClick={() => {
                    navigate("/shortlist-entry-form");
                    roundData = { roundData };
                  }}
                >
                  <PiPlusCircleBold />
                  Shortlist Entry Form
                </GreenContent>
              </div>
            </div>

            <div className="jury_existing_select">
              <div className="jury_existing_select_heading">
                <EventHeading>
                  Want to group your submissions based on specific criteria?
                </EventHeading>
              </div>
              <div className="jury_existing_select_btn">
                <EventHeading>
                  Want to group your submissions based on specific criteria?
                </EventHeading>
                <div className="jury_existing_btn_div">
                  <RedContent
                    className="jury_existing_icon"
                    onClick={() =>
                      navigate("/create-jury-group", {
                        state: {
                          roundId: selectedRoundId,
                          // roundName: round.round_name,
                        },
                      })
                    }                  >
                    <PiPlusCircleBold  />
                    Create New Jury Group(s)
                  </RedContent>

                  {/* {showRoundDropdown && (
                    <div
                      className="round-dropdown"
                      style={{
                        position: "absolute",
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "10px",
                        zIndex: 1000,
                        marginTop: "5px",
                      }}
                    >
                      {roundData.length > 0 ? (
                        roundData.map((round) => (
                          <div
                            key={round.roundId}
                            style={{
                              padding: "8px",
                              cursor: "pointer",
                              ":hover": { backgroundColor: "#f5f5f5" },
                            }}
                            // Update the onClick handler for round selection
                            onClick={() =>
                              navigate("/create-jury-group", {
                                state: {
                                  roundId: round.roundId,
                                  roundName: round.round_name,
                                },
                              })
                            }
                          >
                            {round.round_name}
                          </div>
                        ))
                      ) : (
                        <div style={{ padding: "8px", color: "#666" }}>
                          No rounds available
                        </div>
                      )}
                    </div>
                  )} */}

                  <RedContent
                    className="jury_existing_icon"

                    onClick={() => navigate("/view-group")}
                  >
                    <MdOutlineSettings />
                    View Jury Group(s)
                  </RedContent>
                </div>
              </div>
            </div>

            <div className="jury_existing_icon_content">
              <div
                className="jury_existing_sub_icon"
                style={{ color: "#C32728" }}
              >
                <RiDeleteBin6Fill />
                <DescriptionContent
                  style={{ color: "#C32728", cursor: "pointer" }}
                  onClick={handleDelete}
                >
                  Remove{" "}
                </DescriptionContent>
              </div>

              <div
                className="jury_existing_sub_icon"
                style={{ color: "#00AC4F" }}
              >
                <IoMdCheckmark />

                <DescriptionContent
                  style={{ color: "#00AC4F", cursor: "pointer" }}
                  onClick={() => window.location.reload()}
                >
                  Force Refresh
                </DescriptionContent>
              </div>
            </div>

            <div className="jury_existing_submission_div">
              <div
                className="jury_existing_sub_submission"
                style={{
                  backgroundColor: selectedButton === 0 ? "#FFE2E5" : "#F6F8F9",
                }}
                onClick={() => {
                  handleClick(0);
                  setSelectedRows(data.map(row => row.rowId)); // Select all rows
                }}
              >
                <RedMainHeading>
                  Viewing: {data.length} submissions
                </RedMainHeading>
                <JuryRound>Select all submissions</JuryRound>
              </div>

              <div
                className="jury_existing_sub_submission"
                style={{
                  backgroundColor: selectedButton === 1 ? "#FFE2E5" : "#F6F8F9",
                }}
                onClick={() => {
                  handleClick(1);
                  setSelectedRows([]); // Deselect all rows
                }}
              >
                <RedMainHeading>
                  Selected: {selectedRows.length} submissions
                </RedMainHeading>
                <JuryRound>Deselect all selected submissions</JuryRound>
              </div>
            </div>

            <div className="jury_existing__table_div">
              <div className="jury_existing__table_search">
                <div className="jury_existing__table_icon">
                  <IoSearchSharp />
                </div>
                <div className="jury_existing__table_icon_content">
                  <input
                    type="text"
                    placeholder="Start typying  to filter grid"
                  />
                </div>
              </div>

              <GreyfilterButton className="jury_existing__filter_icon">
                <LuFilter />
                Filter
              </GreyfilterButton>
            </div>

            {selectedButton === 0 && (
              <GlobalSecondTable
                data={data}
                columns={columns}
                selectedRows={selectedRows} // Ensure this is always an array
                onCheckboxChange={handleCheckboxChange}
                onRowClick={setSelectedRow}
              />
            )}

            {selectedButton === 1 && (
              <GlobalSecondTable
                data={data}
                columns={columns}
                selectedRows={selectedRows} // Ensure this is always an array
                onCheckboxChange={handleCheckboxChange}
                onRowClick={setSelectedRow}
              />
            )}
          </>) : (<div style={{ color: "red", textAlign: "center" }}> Please Select A Round</div>)}
        </div>
      </div>
    </div>
  );
};
